import React, { Component } from 'react';
import Wsde from './wsde_rmgl';
import './wsde.css';
import Notice from "../notice/notice"
import { Route } from 'react-router-dom';
// import * as data from '../data/locations.geojson';

class WsdeHold extends Component { 
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.state = {
      loadReady: false,
      converted:[],
      data:[],
      showNotice: true,
      location: []
    };
  }

  componentDidMount() {
    var mapHolder = document.getElementById('mapHolder');
    mapHolder.classList.add('wsdeOn');
    document.title = "BSA: The Dual Power Map"
    this.getData();
  }

  // componentDidUpdate(){


  // }

  componentWillUnmount() {
    var mapHolder = document.getElementById('mapHolder');
    mapHolder.classList.remove('wsdeOn');
  }

  getData = () => {
    fetch('/api/wsde')
    .then(res => res.json())
    .then(data => this.setState({ data: data.data }, () => {
      this.getLoc()
  
    }));
  }

  getLoc=()=>{
    let data = this.state.data;
    let loc = {}
    loc.type = "FeatureCollection"
    loc.features = []
    data.forEach(function(e){
      let curr = {}
      curr.type = "Feature"
      curr.properties = {}
      curr.properties.Title = e.title;
      curr.properties.Website = e.website;
      curr.properties.Normalized_Website = e.normURL;
      curr.properties.City = e.city;
      curr.properties.state = e.state;
      curr.properties.Location = e.location;
      curr.properties.Category = e.type;
      curr.properties.Address = e.address;
      curr.geometry = {}
      curr.geometry.type ="Point";
      curr.geometry.coordinates =[e.lng, e.lat];
      loc.features.push(curr)

    })

    this.setState({ location:loc }, ()=>{
      this.setState({loadReady:true})
    }); 
  }




  toggleNotice = () => {
    const noticeState = this.state.showNotice;
    this.setState({showNotice: !noticeState});
    const notice = document.getElementById('notice');
  

  }

  // convertData = () => {
  //   var locCount = this.state.data.length
  //   var currentCount = 1
  //   console.log(locCount)
  //   let full = {
  //     "type": "FeatureCollection",
  //     "features": []
  //   };
  //   while(currentCount < locCount){
  //     let converted = {
  //       "type": "Feature",
  //       "properties": {},
  //       "geometry": {
  //         "type": "Point",
  //         "coordinates": [
  //           this.state.data[currentCount-1].lng,
  //           this.state.data[currentCount-1].lat
  //         ]
  //       }
  //     }
  //     full.features.push(converted);
  //     currentCount++
  //   }

  // convertData = () => {
  //   var locCount = this.state.data.length
  //   var currentCount = 1
  //   console.log(locCount)
  //   let full = []
  //   while(currentCount < locCount) {
  //     full.push( <Marker position={[this.state.data[currentCount-1].lng, this.state.data[currentCount-1].lat]} title={this.state.data[currentCount-1].title} />)
  //     currentCount++
  //   }
  //   this.setState({converted: full}, () => {
  //     this.setState({loadReady: true})
  //   })
  // }

  render() {
    return (
      <div id="mapHolder" style={{height: window.innerHeight, width: window.innerWidth}}>
        <React.Fragment>
          <Route path='/dual-power-map' render={()=><Notice showNotice={this.state.showNotice} hideNav={this.props.hideNav}  mapVis={this.state.mapVis} toggleNotice={this.toggleNotice}/>} />
          <div className={`dual-power-map fullWidth fullHeight ${this.state.showNotice?"hide":''}`}>
          {this.state.loadReady ? (
            <Route path='/dual-power-map' render={()=><Wsde showNotice={this.state.showNotice} location={this.state.location} hideNav={this.props.hideNav} showNav={this.props.showNav} mapVis={this.state.mapVis} toggleNotice={this.toggleNotice}/>} />    
          ):(
            ""
          )}
          </div>
        </React.Fragment>   
      </div>
    )
  }
}

export default WsdeHold


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/wsdeHold.js